/* eslint-disable no-console */
/* eslint-disable no-useless-catch */
import httpService from "@/shared/http";
import { store } from "@/main";
import { pathOr, has } from "ramda";
import {
  generateApiUrl,
  storeDispatcher,
  calcPercentage,
  getActiveParvandeh,
  downloadBlob,
} from "@/shared/utils";

export const getUserInfo = async () => {
  try {
    const url = generateApiUrl(["globalServices", "user_info"]);
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    await storeDispatcher("userInfo", data);

    return {};
  } catch (error) {
    throw error;
  }
};
export const getMenu = async () => {
  try {
    await storeDispatcher("menuItems", []);
    const url = generateApiUrl(["globalServices", "menu"]);
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data", "result"], response);
    const menuItems = pathOr([], ["data"], data);
    const dynamicRouteName = pathOr(null, ["route_name"], data);
    await storeDispatcher("menuItems", menuItems);
    await storeDispatcher("dynamicRouteName", dynamicRouteName);

    return {};
  } catch (error) {
    throw error;
  }
};
export const getMyParvandeh = async () => {
  try {
    const url = generateApiUrl(["globalServices", "my_parvandeh"]);
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);

    return { items: data };
  } catch (error) {
    throw error;
  }
};
export const parvandehChangeRole = async (parvandeh) => {
  try {
    const url = generateApiUrl(["globalServices", "parvandeh_change_role"]);
    const payload = { code: pathOr(null, ["code"], parvandeh) };
    const response = await httpService.put(url, payload);
    const message = pathOr(null, ["data", "message"], response);
    await getUserInfo();
    await getMenu();
    localStorage.setItem("activeParvandeh", JSON.stringify(parvandeh));

    return { message };
  } catch (error) {
    throw error;
  }
};
export const getParvandehStatusDetail = async (code) => {
  try {
    const parvandehCode = code || getActiveParvandeh(["code"]);
    const url = generateApiUrl(
      ["globalServices", "parvandeh_status_detail"],
      [parvandehCode]
    );
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);
    const totalItemCount = pathOr(0, ["total_item"], data);
    const totalIncompleteItemCount = pathOr(0, ["total_incomplete_item"], data);
    const percent = calcPercentage(+totalItemCount, +totalIncompleteItemCount);
    const items = pathOr([], ["tabs", "0", "items"], data).map((item) => {
      return {
        icon: pathOr("", ["icon"], item),
        caption: pathOr("", ["tab_caption"], item),
        time: pathOr("", ["duration_time"], item),
        done: pathOr(false, ["complete_status"], item),
        link: pathOr(null, ["link"], item),
        hasData: has("has_data", item) ? item.has_data : "",
        subItems: pathOr([], ["message"], item),
      };
    });

    return { totalIncompleteItemCount, percent, items };
  } catch (error) {
    throw error;
  }
};
export const exportExcel = async (resource, filters) => {
  try {
    const url = generateApiUrl(["globalServices", "exportExcel"], [resource]);
    const payload = { filters };
    const response = await httpService.patch(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const getPersonInformation = async (code) => {
  try {
    const url = generateApiUrl(["globalServices", "person_export_pdf"], [code]);
    const response = await httpService.get(url);
    const data = pathOr([], ["data", "data"], response);

    return { ...data };
  } catch (error) {
    throw error;
  }
};
export const getParvandehReportList = async (code, resource, resource_id) => {
  try {
    const queryString =
      resource && resource_id ? { resource, resource_id } : {};
    const url = generateApiUrl(
      ["globalServices", "parvandeh_report"],
      [code],
      queryString
    );
    const response = await httpService.get(url);
    const items = pathOr([], ["data", "data"], response);
    const permissions = pathOr([], ["data", "permissions"], response);

    return { items, permissions };
  } catch (error) {
    throw error;
  }
};
export const deleteReport = async (id) => {
  try {
    const url = generateApiUrl(["globalServices", "report_id"], [id]);
    const response = await httpService.delete(url);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const addEnumItem = async (caption, categoryName, parentId) => {
  try {
    const url = generateApiUrl(["globalServices", "enum"]);
    const payload = {
      enum_caption: caption,
      category_name: categoryName,
      parent_id: parentId,
    };
    const response = await httpService.post(url, payload);
    await store.dispatch("getAllEnumeration");
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const generateOtpCode = async (mode, mobile) => {
  try {
    const url = generateApiUrl(["globalServices", "generate_otp_code"]);
    const payload = { model_request: mode, mobile };
    const response = await httpService.post(url, payload);
    const data = pathOr(null, ["data", "data"], response);
    return {
      controlCode: pathOr(null, ["control_code"], data),
      expireSeconds: pathOr(null, ["expire_seconds"], data),
      mobile: pathOr(null, ["mobile"], data),
    };
  } catch (error) {
    throw error;
  }
};
export const generateMobileOtpForMe = async (mode, mobile) => {
  try {
    const url = generateApiUrl(["globalServices", "generateMobileOtpForMe"]);
    const payload = { model_request: mode, mobile };
    const response = await httpService.get(url, payload);
    const data = pathOr(null, ["data", "data"], response);
    return {
      controlCode: pathOr(null, ["control_code"], data),
      expireSeconds: pathOr(null, ["expire_seconds"], data),
      expireAt: pathOr("", ["expire_at"], data),
      mobile: pathOr(null, ["mobile"], data),
    };
  } catch (error) {
    throw error;
  }
};
export const setPersonContent = async ({
  resourceName,
  resourceId,
  name,
  description = null,
  reference,
}) => {
  try {
    const url = generateApiUrl(
      ["globalServices", "keyValuePersonContent"],
      [resourceName, resourceId]
    );
    const payload = { name, description, reference };
    const response = await httpService.post(url, payload);
    const id = pathOr(null, ["data", "data"], response);

    return { id };
  } catch (error) {
    throw error;
  }
};
export const updateReportSetting = async (
  reportSettingId,
  introduction,
  logo
) => {
  try {
    const url = generateApiUrl(
      ["globalServices", "reportSetting"],
      [reportSettingId]
    );
    const payload = { settings: { introduction, logo } };
    const response = await httpService.put(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const getActivity = async (resourceName, resourceValue, id) => {
  try {
    const url = generateApiUrl(
      ["globalServices", "activity"],
      [resourceName, resourceValue, id]
    );
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    const permissionsData = pathOr(null, ["permissions"], response);
    const action = pathOr(null, ["action"], data);
    const termState = pathOr(null, ["term_state_code"], data);

    const getData = {
      id: pathOr(null, ["id"], data),
      title: pathOr(null, ["caption"], data),
      description: pathOr(null, ["description"], data),
      stateDefine: termState
        ? {
            id: pathOr(null, ["id"], termState),
            caption: pathOr("", ["caption"], termState),
          }
        : null,
      pagesReference: action
        ? {
            id: pathOr(null, ["id"], action),
            caption: pathOr("", ["caption"], action),
          }
        : null,
      timeCheckpoint: pathOr(0, ["time_checkpoint"], data),
      viewTime: Math.abs(pathOr(0, ["diff_time_checkpoint"], data)),
      comparisonCondition: pathOr(0, [""], data),
      durationActivity: pathOr(null, ["duration"], data),
      startAtTime: !!pathOr(0, ["start_at_time"], data),
      startAtPeriod: !!pathOr(0, ["start_at_period"], data),
      previousStepRequired: !!pathOr(0, ["has_prerequisite"], data),
      guideText: pathOr("", ["guide_text"], data),
      isCreatedTask: pathOr(false, ["is_created_task"], data),
    };

    return { getData, permissionsData };
  } catch (error) {
    throw error;
  }
};
export const addActivity = async ({
  resourceName,
  resourceValue,
  termId,
  title,
  description,
  stateDefineId,
  pagesReferenceId,
  timeCheckpointId,
  diffTimeCheckpoint,
  durationActivity,
  startAtTime,
  startAtPeriod,
  previousStepRequired,
  files,
}) => {
  try {
    const url = generateApiUrl(
      ["globalServices", "activities"],
      [resourceName, resourceValue]
    );
    const payload = {
      term_id: termId,
      caption: title,
      description,
      term_state_code: stateDefineId,
      custom_action_id: pagesReferenceId,
      time_checkpoint: timeCheckpointId,
      diff_time_checkpoint: diffTimeCheckpoint,
      duration: durationActivity,
      start_at_time: startAtTime,
      start_at_period: startAtPeriod,
      has_prerequisite: previousStepRequired,
      files,
    };
    const response = await httpService.post(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const updateActivity = async ({
  resourceName,
  resourceValue,
  termId,
  id,
  title,
  description,
  stateDefineId,
  pagesReferenceId,
  timeCheckpointId,
  diffTimeCheckpoint,
  durationActivity,
  startAtTime,
  startAtPeriod,
  previousStepRequired,
  files,
}) => {
  try {
    const url = generateApiUrl(
      ["globalServices", "activity"],
      [resourceName, resourceValue, id]
    );
    const payload = {
      term_id: termId,
      caption: title,
      description,
      term_state_code: stateDefineId,
      custom_action_id: pagesReferenceId,
      time_checkpoint: timeCheckpointId,
      diff_time_checkpoint: diffTimeCheckpoint,
      duration: durationActivity,
      start_at_time: startAtTime,
      start_at_period: startAtPeriod,
      has_prerequisite: previousStepRequired,
      files,
    };
    const response = await httpService.put(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const deleteActivity = async (resourceName, resourceValue, id) => {
  try {
    const url = generateApiUrl(
      ["globalServices", "activity"],
      [resourceName, resourceValue, id]
    );
    const response = await httpService.delete(url);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const getCaptcha = async () => {
  try {
    await storeDispatcher("menuItems", []);
    const url = generateApiUrl(["globalServices", "captcha"]);
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    const mimeType = pathOr(null, ["mime_type"], data);
    const base64Src = pathOr(null, ["captcha"], data);
    const resCaptchaImage = `data:${mimeType};base64,${base64Src}`;
    const resCaptchaKey = pathOr(null, ["key"], data);
    const resExpireSeconds = pathOr(null, ["expire_seconds"], data);
    const resShow = pathOr(false, ["show_captcha"], data);

    return { resCaptchaImage, resCaptchaKey, resExpireSeconds, resShow };
  } catch (error) {
    throw error;
  }
};
export const getAttachmentOriginal = async (code) => {
  try {
    const url = generateApiUrl(
      ["globalServices", "attachmentOriginal"],
      [code]
    );
    const response = await httpService.get(url, false, {
      responseType: "blob",
    });
    const data = pathOr("", ["data"], response);
    const src = data ? URL.createObjectURL(data) : "";
    return { src };
  } catch (error) {
    throw error;
  }
};
export const getAttachmentDownload = async (code) => {
  try {
    const url = generateApiUrl(
      ["globalServices", "attachmentDownload"],
      [code]
    );
    const response = await httpService.get(url, false, {
      responseType: "blob",
    });
    const data = pathOr("", ["data"], response);
    if (data) {
      downloadBlob(data);
    }
  } catch (error) {
    throw error;
  }
};
export const getAttachmentDownloadFile = async (
  code,
  downloadFileName = ""
) => {
  try {
    const url = generateApiUrl(
      ["globalServices", "attachmentDownloadFile"],
      [code]
    );
    const response = await httpService.get(url, false, {
      responseType: "blob",
    });
    const data = pathOr("", ["data"], response);
    if (data) {
      downloadBlob(data, downloadFileName);
    }
  } catch (error) {
    throw error;
  }
};
export const getAttachmentDownloadSrc = async (code) => {
  try {
    const url = generateApiUrl(
      ["globalServices", "attachmentDownload"],
      [code]
    );
    const response = await httpService.get(url, false, {
      responseType: "blob",
    });
    const data = pathOr("", ["data"], response);
    const src = data ? URL.createObjectURL(data) : "";
    return { src };
  } catch (error) {
    throw error;
  }
};
export const getPersonProfilePreviewPdf = async (code, captcha, key) => {
  try {
    const url = generateApiUrl(
      ["globalServices", "personProfilePreviewPdf"],
      [code]
    );
    const payload = { captcha, key };
    const response = await httpService.patch(url, payload, {}, true, {
      responseType: "blob",
    });
    const data = pathOr("", ["data"], response);
    if (data) {
      downloadBlob(data);
    }
  } catch (error) {
    throw error;
  }
};
